import { ObjectSchema, object, array } from 'yup';
import { noop } from '@utils/noop';
import { Dispatch, createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';

export type AddRolePermissionsFormState = {
  permissions: [];
};

export const addRolePermissionsFormStateDefault: AddRolePermissionsFormState = {
  permissions: [],
};

// @ts-ignore
export const addRolePermissionsSchemaDefault: ObjectSchema<Partial<AddRolePermissionsFormState>> =
  object<Partial<AddRolePermissionsFormState>>().shape({
    permissions: array().required('Permissions is required field'),
  });

type AddRolePermissionsFormContextType = {
  schema: ObjectSchema<Partial<AddRolePermissionsFormState>>;
  setSchema: Dispatch<ObjectSchema<Partial<AddRolePermissionsFormState>>>;
  methods?: UseFormReturn<AddRolePermissionsFormState>;
};

const addRolePermissionsFormContextDefault = {
  schema: addRolePermissionsSchemaDefault,
  setSchema: noop,
} satisfies AddRolePermissionsFormContextType;

export const AddRolePermissionsFormContext = createContext<AddRolePermissionsFormContextType>(
  addRolePermissionsFormContextDefault
);

export const useAddRolePermissionsForm = () => {
  const { methods } = useContext(AddRolePermissionsFormContext);
  if (!methods) {
    throw new Error('AddRolePermissionsFormContext is empty');
  }

  return methods;
};

export const useManageCreateAviatorRoleSchema = () => {
  const { setSchema } = useContext(AddRolePermissionsFormContext);

  return { setSchema };
};
